import { MULTI_ADS_TYPE_PLURAL } from './constants';
import { IOffer } from '../../../../types/offer';

export function getMultiAdsTypePlural(offer: IOffer): string | undefined {
  const category = offer.category;

  if (!category) {
    return undefined;
  }

  for (const stem of Object.keys(MULTI_ADS_TYPE_PLURAL)) {
    if (category === `${stem}Rent` || category === `${stem}Sale`) {
      return MULTI_ADS_TYPE_PLURAL[stem];
    }
  }

  return undefined;
}
